import { c as _c } from "react/compiler-runtime";
import { useUserContext } from '@module/mdrt-org/shared/components/providers/user-context';
import { useRouter } from '@module/mdrt-org/shared/i18n/i18n-navigation';
import { ERROR_PATH } from '@module/mdrt-org/shared/utils/constants/local-paths';
import { getPublicEnvironmentVariables } from '@module/mdrt-org/shared/utils/helpers/get-public-environment-variables';
import { type CustomerProfile } from '@module/mdrt-org/shared/utils/types/customer-profile';
import { logErrorMessage } from '@shared/utils/helpers/error-logging';
export const useGetNullableCustomerProfile = () => {
  const $ = _c(3);
  const {
    accessToken
  } = useUserContext();
  const router = useRouter();
  let t0;
  if ($[0] !== accessToken || $[1] !== router) {
    t0 = {
      getNullableCustomerProfile: async t1 => {
        const {
          personId
        } = t1;
        const environment = await getPublicEnvironmentVariables();
        const response = await fetch(`${environment.apiBaseUrl}/${environment.apiRoute}/CustomerProfile/${personId}`, {
          headers: {
            Authorization: accessToken ? `Bearer ${accessToken}` : "",
            "Ocp-Apim-Subscription-Key": environment.ocpApiSubscriptionKey ?? ""
          }
        });
        if (response.status === 404) {
          return null;
        }
        if (response?.status !== 200) {
          logErrorMessage(`${response?.url} returned status ${response?.status}, ${await response?.text()}`, ["${environment.apiBaseUrl}/${environment.apiRoute}/CustomerProfile/${personId}", response?.status?.toString() ?? "0"]);
          router.push(ERROR_PATH);
        }
        return await response?.json();
      }
    };
    $[0] = accessToken;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};